import React, { useEffect } from 'react';
import { Card, CardContent } from './ui/card';

const FacebookFeed = () => {
  useEffect(() => {
    // Load Facebook SDK
    if (window.FB) {
      window.FB.XFBML.parse();
    } else {
      const script = document.createElement('script');
      script.src = 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v18.0';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <Card className="overflow-hidden">
      <CardContent className="p-0">
        <div 
          className="fb-page" 
          data-href="https://www.facebook.com/100432836071005"
          data-tabs="timeline"
          data-width="500"
          data-height="600"
          data-small-header="false"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="true"
        >
          <blockquote 
            cite="https://www.facebook.com/100432836071005" 
            className="fb-xfbml-parse-ignore"
          >
            <a href="https://www.facebook.com/100432836071005">
              Millie's Motorhome Hire
            </a>
          </blockquote>
        </div>
      </CardContent>
    </Card>
  );
};

export default FacebookFeed;
